import * as remoteConfigFetch from './remote-config';
export { RemoteConfigFetch } from './types';
export const { createRemoteConfigFetch } = remoteConfigFetch;
